import { render, staticRenderFns } from "./SpeakStraight.vue?vue&type=template&id=a4e4951a&scoped=true&"
import script from "./SpeakStraight.vue?vue&type=script&lang=js&"
export * from "./SpeakStraight.vue?vue&type=script&lang=js&"
import style0 from "./SpeakStraight.vue?vue&type=style&index=0&id=a4e4951a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4e4951a",
  null
  
)

export default component.exports